<template>
  <div id="calculator">
    <aerocrete-calculator/>
  </div>
</template>

<script>
  import AerocreteCalculator from './components/AerocreteCalculator'

  export default {
    name: 'app',
    components: {
      AerocreteCalculator
    },
    computed: {}
  }
</script>

<style>
</style>
